import { TemplateKey } from "PFApp/constants/templates";
import { useFormSectionsGenerator } from "PFApp/hooks/activity_form/use_form_sections_generator";
import { useTemplate } from "PFApp/hooks/index.js";
import { useEffect } from "react";

import { useActivityFormStoreActions } from "../activity_form_store";
import { useActivityFormStore } from "../activity_form_store";
import { useIsSubtemplatesLogicActive } from "./use_is_subtemplates_logic_active";
import { useShowInterestQuestions } from "./use_show_interest_questions";
import { useSubtemplate } from "./use_subtemplate";

export const useSetFormSchema = () => {
  const { isNew, isRole, isAudit, isEngagement, isDraft } = useActivityFormStore(
    (state) => state.activityStatus
  );
  const activityCreator = useActivityFormStore((state) => state.activityCreator);
  const template = useActivityFormStore((state) => state.template);
  const parentActivity = useActivityFormStore((state) => state.parentActivity);
  const { setFormSchema } = useActivityFormStoreActions();

  const subtemplate = useSubtemplate();
  const isQuestionsSectionVisible = useShowInterestQuestions();
  const isSubtemplateSectionVisible = useIsSubtemplatesLogicActive();

  const engagementKey = isAudit ? TemplateKey.AuditEngagement : TemplateKey.Engagement;
  const engagementTemplate = useTemplate({ key: engagementKey });
  const isParentActivityVisible = template.schema?.rules?.hide_parent_activity_id !== true;
  const isEngagementVisible = isParentActivityVisible && isRole && !!engagementTemplate;

  const { generateFormSections } = useFormSectionsGenerator({
    isSubtemplateSectionVisible,
    template,
    subtemplate,
    activityCreator,
    parentActivity,
    isRole,
    isEngagement,
    isEngagementVisible,
    isDraft,
    isNew,
    isQuestionsSectionVisible
  });

  useEffect(() => {
    const formSchema = generateFormSections();
    setFormSchema(formSchema);
  }, [generateFormSections, setFormSchema]);
};
